const Showcase = () => {
  return (
    <section id="home" className="px-12 md:px-28 py-12">
      <div
        className="relative flex flex-col justify-center items-center text-center min-h-[70vh] md:min-h-[80vh]"
        style={{
          backgroundImage: "url(/landscape.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="absolute top-0 right-0 bg-black opacity-90 w-[100%] min-h-[70vh] md:min-h-[80vh]" />
        <h3 className="text-2xl" style={{ zIndex: 2 }}>
          Hello
        </h3>
        <h1
          className="uppercase text-3xl font-extrabold mt-8 mb-6 md:typed md:mt-6 md:mb-8 md:text-6xl"
          style={{ zIndex: 2 }}
        >
          I&apos;m Anselm Iwuanyanwu
        </h1>
        <h3 className="capitalize text-xl" style={{ zIndex: 2 }}>
          A <span className="text-primary"> fullstack developer</span>
        </h3>

        <a
          href="#contact"
          className="button mt-8 md:mt-6 md:mb-8"
          style={{ zIndex: 2 }}
        >
          Hire Me
        </a>
      </div>
    </section>
  );
};

export default Showcase;
